(() => {
  'use strict';
  if (window.location.pathname !== '/pages/red-light-therapy-brands-compared') return;
  const bar = document.querySelector('[data-rlc-brands-bar]');
  if (!bar) return;
  const menu = bar.querySelector('[data-rlc-brands-menu]');
  const summary = menu && menu.querySelector('summary');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 767px)');
  const close = (focus = false) => {
    if (!menu || !menu.open) return;
    menu.open = false;
    if (focus && summary) summary.focus({preventScroll: true});
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (link && bar.contains(link) && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const destination = new URL(link.href, location.href);
      if (destination.origin === location.origin && destination.pathname === location.pathname && destination.hash) {
        let id;
        try { id = decodeURIComponent(destination.hash.slice(1)); } catch { return; }
        const target = id === 'rlc-brands-top' ? document.body : document.getElementById(id);
        if (target) {
          event.preventDefault();
          close();
          const top = id === 'rlc-brands-top' ? 0 : Math.max(0, target.getBoundingClientRect().top + scrollY - bar.getBoundingClientRect().height - 20);
          if (location.hash !== destination.hash) history.pushState(null, '', destination.hash);
          window.scrollTo({top, behavior: reduced.matches ? 'auto' : 'smooth'});
          if (id !== 'rlc-brands-top') {
            const had = target.hasAttribute('tabindex');
            if (!had) target.setAttribute('tabindex', '-1');
            target.focus({preventScroll: true});
            if (!had) target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once: true});
          }
        }
      }
    }
    if (menu && menu.open && !menu.contains(event.target)) close(menu.contains(document.activeElement));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu && menu.open) { event.preventDefault(); close(true); }
  });
  if (mobile.addEventListener) mobile.addEventListener('change', () => { if (!mobile.matches) close(); });
})();
